import coverImg from '../../../assets/images/literature/atlantic-telegraph-cover.jpg';

const SEGMENTS = [
    {
        id: 'segment-1',
        title: 'A Nothing of Time',
        stanzas: [1],
        text: `World! what a wonder is this,
Grandly and simply sublime,—
All the Atlantic abyss
Leapt in a nothing of time!
Even the steeds of the sun
Half a day panting behind,
In the flat race that is run,
Won by a flash of the mind!`,
        morseText: '| | | WORLD WHAT A WONDER IS THIS GRANDLY AND SIMPLY SUBLIME BK ALL THE ATLANTIC ABYSS LEAPT IN A NOTHING OF TIME BK EVEN THE STEEDS OF THE SUN HALF A DAY PANTING BEHIND BK IN THE FLAT RACE THAT IS RUN WON BY A FLASH OF THE MIND BK',
        estimatedSeconds: { wpm15: 90, wpm20: 67, wpm25: 54 },
        questions: [
            {
                id: 'atlantic-q1',
                question: 'What is the "flash of the mind" refers to?',
                options: ['THOUGHT', 'ELECTRICITY', 'LIGHTNING', 'SUNLIGHT'],
                answer: 'THOUGHT',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'segment-2',
        title: 'Sensitive Link',
        stanzas: [2],
        text: `Lo! on this sensitive, link—
It is one link, not a chain—
Man with his brother can think
Spanning the breadth of the main,—
Man to his brother can speak
Swift as the bolt from a cloud,
And where its thunders were weak
There his least whisper is loud!`,
        morseText: '| | LO ON THIS SENSITIVE LINK IT IS ONE LINK NOT A CHAIN BK MAN WITH HIS BROTHER CAN THINK SPANNING THE BREADTH OF THE MAIN BK MAN TO HIS BROTHER CAN SPEAK SWIFT AS THE BOLT FROM A CLOUD BK AND WHERE ITS THUNDERS WERE WEAK THERE HIS LEAST WHISPER IS LOUD BK',
        estimatedSeconds: { wpm15: 90, wpm20: 67, wpm25: 54 },
        questions: []
    },
    {
        id: 'segment-3',
        title: 'Conquering Material Ills',
        stanzas: [3],
        text: `Yea; for as Providence wills,
Now doth intelligent man
Conquer material ills,
Wrestling them down as he can,—
And lay one weak little coil
Under the width of the waves,
Distance and Time are his spoil,
Fetter’d as Caliban slaves!`,
        morseText: '| | YEA FOR AS PROVIDENCE WILLS NOW DOTH INTELLIGENT MAN BK CONQUER MATERIAL ILLS WRESTLING THEM DOWN AS HE CAN BK AND LAY ONE WEAK LITTLE COIL UNDER THE WIDTH OF THE WAVES BK DISTANCE AND TIME ARE HIS SPOIL FETTERD AS CALIBAN SLAVES BK',
        estimatedSeconds: { wpm15: 90, wpm20: 67, wpm25: 54 },
        questions: [
            {
                id: 'atlantic-q2',
                question: 'What character from Shakespeare is mention as "fettered"?',
                options: ['ARIEL', 'PUCK', 'CALIBAN', 'PROSPERO'],
                answer: 'CALIBAN',
                difficulty: 'Advanced'
            }
        ]
    },
    {
        id: 'segment-4',
        title: 'Delicate Ariel',
        stanzas: [4],
        text: `Ariel?—right through the sea
We can fly swift as in air;
Puck?—forty minutes shall be
Sloth to the bow that we bear:
Here is Earth’s girdle indeed,
Just a thought-circlet of fire,—
Delicate Ariel freed
Sings, as she flies, on a wire!`,
        morseText: '| | ARIEL RIGHT THROUGH THE SEA WE CAN FLY SWIFT AS IN AIR BK PUCK FORTY MINUTES SHALL BE SLOTH TO THE BOW THAT WE BEAR BK HERE IS EARTHS GIRDLE INDEED JUST A THOUGHT CIRCLET OF FIRE BK DELICATE ARIEL FREED SINGS AS SHE FLIES ON A WIRE BK',
        estimatedSeconds: { wpm15: 90, wpm20: 67, wpm25: 54 },
        questions: []
    },
    {
        id: 'segment-5',
        title: 'Joining the Nations',
        stanzas: [5],
        text: `Courage, O servants of light,
For you are safe to succeed;
Lo! you are helping the Right,
And shall be blest in your deed.
Lo! you shall bind in one band,
Joining the nations as one,
Brethren of every land,
Blessing them under the sun!`,
        morseText: '| | COURAGE O SERVANTS OF LIGHT FOR YOU ARE SAFE TO SUCCEED BK LO YOU ARE HELPING THE RIGHT AND SHALL BE BLEST IN YOUR DEED BK LO YOU SHALL BIND IN ONE BAND JOINING THE NATIONS AS ONE BK BRETHREN OF EVERY LAND BLESSING THEM UNDER THE SUN BK',
        estimatedSeconds: { wpm15: 95, wpm20: 71, wpm25: 57 },
        questions: [
            {
                id: 'atlantic-q4',
                question: 'The poem suggests the cable joins what as one?',
                options: ['COMPUTERS', 'NATIONS', 'SHIPS', 'CITIES'],
                answer: 'NATIONS',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'segment-6',
        title: 'The World’s Nerve',
        stanzas: [6],
        text: `This is Earth’s pulse of high health
Thrilling with vigour and heat,
Brotherhood, wisdom and wealth,
Throbbing in every beat;
But you must watch in good sooth
Lest to false fever it swerve,—
Touch it with tenderest truth
As the world’s exquisite nerve!`,
        morseText: '| | THIS IS EARTHS PULSE OF HIGH HEALTH THRILLING WITH VIGOUR AND HEAT BK BROTHERHOOD WISDOM AND WEALTH THROBBING IN EVERY BEAT BK BUT YOU MUST WATCH IN GOOD SOOTH LEST TO FALSE FEVER IT SWERVE BK TOUCH IT WITH TENDEREST TRUTH AS THE WORLDS EXQUISITE NERVE BK',
        estimatedSeconds: { wpm15: 100, wpm20: 75, wpm25: 60 },
        questions: []
    },
    {
        id: 'segment-7',
        title: 'The First Message',
        stanzas: [7],
        text: `Let the first message across—
High-hearted Commerce, give heed—
Not be of profit or loss,
But one electric indeed:
Praise to the Giver be given,
For that He giveth man skill,
Glory to God in the Heaven!
'Peace upon earth, and goodwill!'`,
        morseText: '| | LET THE FIRST MESSAGE ACROSS HIGH HEARTED COMMERCE GIVE HEED BK NOT BE OF PROFIT OR LOSS BUT ONE ELECTRIC INDEED BK PRAISE TO THE GIVER BE GIVEN FOR THAT HE GIVETH MAN SKILL BK GLORY TO GOD IN THE HEAVEN PEACE UPON EARTH AND GOODWILL BK',
        estimatedSeconds: { wpm15: 110, wpm20: 82, wpm25: 66 },
        questions: [
            {
                id: 'atlantic-q3',
                question: 'What does the poet wish for the first message to be?',
                options: ['BUSINESS PROFIT', 'A PRAYER OF PRAISE', 'WEATHER REPORT', 'NEWS HEADLINES'],
                answer: 'A PRAYER OF PRAISE',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'poem-atlantic-telegraph',
    type: 'poem',
    title: 'The Atlantic Telegraph',
    author: 'Martin Farquhar Tupper',
    publicationDate: '1856',
    coverImage: coverImg,
    genres: ['Inspirational', 'Victorian Poetry', 'Technology', 'Telegraphy', 'Communication'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: 'A stirring Victorian poem celebrating the Atlantic cable as a triumph of the human mind and a tool for global brotherhood.',

    // Non-redundant properties (generated from segments)
    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'Atlantic Ocean / Global',
        period: '1850s (Telegraph era)',
        themes: ['Science', 'Religion', 'Unity', 'Speed', 'Communication'],
        difficulty: 'Beginner',
        estimatedReadingTimeMinutes: 3,
        stanzas: 7,
        rhymeScheme: 'ABAB'
    }
};
